import React, {useEffect} from "react";
import {useContext} from "react";
import {Accordion, ListGroup} from "react-bootstrap";
import {StoreContext} from "../../../store/StoreContext";

const Help = () => {
  const {setAppTitle, help} = useContext(StoreContext);

  useEffect(() => {
    setAppTitle("Preguntas frecuentes");
  }, []);

  return (
    <div className="row">
      <div className="col-12">
        <Accordion defaultActiveKey="0" flush>
          {help.map((h, index) => (
            <Accordion.Item key={h._id} eventKey={index}>
              <Accordion.Header>
                <span className="text-primary-cermaq">
                  {h.question}
                </span>
              </Accordion.Header>
              <Accordion.Body>{h.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default Help;
